<template>
  <div :class="['reset-pass', showpage == 1 || showpage == 2 ? 'bgc' : '']">
    <div v-if="showpage == 1 || showpage == 2" :class="['content', showpage == 1 ? 'height1' : 'height2']">
      <h1>找回密码</h1>
      <t-message v-show="isToastshow" theme="error" icon :duration="2000" :content="message" />
      <div class="content1">
        <speedCom :list="list" nowType="3"></speedCom>
        <div class="email-info">
          <el-form :model="pwdForm" :rules="pwdRules" ref="pwdForm" class="code-from" v-if="showpage == 2">
            <el-form-item prop="phone">
              <el-input v-model="pwdForm.phone" placeholder="请输入账号要绑定的手机号" @focus="clearVerify('pwdForm', 'phone')"
                autocomplete="off" :maxlength="11"></el-input>
            </el-form-item>
            <el-form-item prop="code" class="code-item">
              <el-input v-model="pwdForm.code" placeholder="请输入验证码" @focus="clearVerify('pwdForm', 'code')"
                @change="codeChange" autocomplete="off" :maxlength="6"></el-input>
              <div :class="[codeBtnVal == '获取验证码' ? 'get-code' : 'get-code2']" @click="clickCode">
                {{ codeBtnVal }}
              </div>
            </el-form-item>
            <el-form-item prop="password">
              <el-input :type="passwordFlag" v-model="pwdForm.password" placeholder="数字、字母、符号(_-@&=.)组合的8-18位新密码"
                @focus="clearVerify('pwdForm', 'password')" :maxlength="18" class="pwd-item"
                autocomplete="new-password"></el-input>
              <i :class="[
    'open-pwd',
    passwordFlag == 'password' ? 'icon1' : 'icon2',
  ]" @click="openPwd()"></i>
            </el-form-item>
            <el-form-item prop="confirmPassword">
              <el-input :type="passwordFlag1" v-model="pwdForm.confirmPassword" placeholder="请再次输入新密码"
                @focus="clearVerify('pwdForm', 'confirmPassword')" :maxlength="18" class="pwd-item"
                autocomplete="new-password"></el-input>
              <i :class="[
    'open-pwd',
    passwordFlag1 == 'password' ? 'icon1' : 'icon2',
  ]" @click="openPwd1()"></i>
            </el-form-item>
          </el-form>

          <el-form :model="pwdForm2" :rules="pwdRules2" ref="pwdForm2" class="code-from" v-else-if="showpage == 1">
            <el-form-item prop="password2">
              <el-input :type="passwordFlag" v-model="pwdForm2.password2" placeholder="数字、字母、符号(_-@&=.)组合的8-18位新密码"
                @focus="clearVerify('pwdForm2', 'password2')" :maxlength="18" class="pwd-item"
                autocomplete="new-password"></el-input>
              <i :class="[
    'open-pwd',
    passwordFlag == 'password' ? 'icon1' : 'icon2',
  ]" @click="openPwd()"></i>
            </el-form-item>
            <el-form-item prop="confirmPassword2">
              <el-input :type="passwordFlag1" v-model="pwdForm2.confirmPassword2" placeholder="请再次输入新密码"
                @focus="clearVerify('pwdForm2', 'confirmPassword2')" :maxlength="18" class="pwd-item"
                autocomplete="new-password"></el-input>
              <i :class="[
    'open-pwd',
    passwordFlag1 == 'password' ? 'icon1' : 'icon2',
  ]" @click="openPwd1()"></i>
            </el-form-item>
          </el-form>
          <div class="btn-box">
            <div class="btn" @click="findpwd">{{ registerName }}</div>

            <p v-show="this.showpage == 2">
              根据《中华人民共和国网络安全法》要求，使用互联网服务需要进行身份信息验证。请绑定手机号验证，感谢你的支持和理解。
            </p>
            <p class="p3"><span @click="toHome">返回登录</span></p>
          </div>
        </div>
      </div>
    </div>
    <div class="noInfo" v-else>
      <img src="../assets/reset-pass/noinfo.png" alt="" />
      <p>该邮箱激活链接已过期，请尝试重新找回</p>
      <div class="btn" @click="backfindpassword">找回密码</div>
    </div>
    <!--滑块验证-->
    <slider-verify ref="sliderVerify" @closeDialog="closeDialog" @success="onSuccess" @again="onAgain" />
  </div>
</template>

<script>
import {
  getDynamicCode,
  resetUserPassword,
  bindEmail,
  getToResetEmail,
  userLogin,
} from "@/../api";
import { mapState, mapMutations } from "vuex";
import { getQueryString, zhugeTrack, jumpAfterLogin } from "@/utils/utils";
import speedCom from "@/components/common/speed";
import sliderVerify from "@/components/common/puzzleVerify";
export default {
  name: "toResetEmail",
  components: { speedCom, sliderVerify },

  watch: {
    "sliderResult": {
      handler(val) {
        if (val) {
          this.getCode(val)
        }
      },
      deep: true,
      immediate: true
    },
  },
  data() {
    return {
      urlemail: "",
      urlcode: "",
      showpage: 2,
      showcode: 0,
      passwordFlag: "password",
      passwordFlag1: "password",
      list: ["输入邮箱", "邮箱验证", "重置密码"],
      referUrl: "",
      codeErr: false,
      codeerrorMessage: "请输入正确验证码，连续输入错误，账号将被锁定",
      codeLogin: "",
      vcode: "",
      emailName: "",
      pawErrMsg: "",
      phoneErr: false,
      pwdError: false, // 校验密码是否错误
      code: "",
      codeBtnVal: "获取验证码",
      registerName: "重置并登录",
      pwdForm: {
        phone: "",
        code: "",
        password: "",
        confirmPassword: "",
      },
      pwdForm2: {
        password2: "",
        confirmPassword2: "",
      },
      pwdRules2: {
        password2: [
          { required: true, message: "请输入数字、字母、符号(_-@&=.)组合的8-18位新密码", trigger: "blur" },
          {
            pattern:
              /^(?=.*?[a-zA-Z])(?=.*?[0-9])(?=.*?[_\-@&=.])[a-zA-Z0-9_\-@&=.]{8,18}$/i,
            message: "必须为8-18位数字、字母、常用符号(_-@&=.)组合",
            trigger: "blur",
          },
        ],
        confirmPassword2: [
          { required: true, message: "请再次输入新密码", trigger: "blur" },
          { validator: this.confirmPwdValidator2, trigger: "blur" },
        ],
      },

      pwdRules: {
        phone: [
          { validator: this.phoneValidator },
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1\d{10}$/,
            message: "手机号格式不正确",
            trigger: "blur",
          },
        ],

        code: [
          { validator: this.codeValidator },
          { required: true, message: "请输入动态验证码", trigger: "blur" },
          { min: 6, max: 6, message: "请输入动态验证码", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入数字、字母、符号(_-@&=.)组合的8-18位新密码", trigger: "blur" },
          {
            pattern:
              /^(?=.*?[a-zA-Z])(?=.*?[0-9])(?=.*?[_\-@&=.])[a-zA-Z0-9_\-@&=.]{8,18}$/i,
            message: "必须为8-18位数字、字母、常用符号(_-@&=.)组合",
            trigger: "blur",
          },
        ],
        confirmPassword: [
          { required: true, message: "请再次输入新密码", trigger: "blur" },
          { validator: this.confirmPwdValidator, trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    ...mapState(["isToastshow", "message", "isShowSliderVerify", 'sliderResult']),
  },
  mounted() {
    this.isShowPhoneCode();
    // 获取登录页跳转的页面
    this.referUrl = getQueryString("refer")
      ? decodeURIComponent(getQueryString("refer"))
      : "";
    // 是否是回车课堂登录页
    this.codeLogin = getQueryString("codeLogin");
    // URl参数
    this.vcode = getQueryString("vcode");
    if (this.vcode) {
      var index = this.vcode.indexOf("!");
      // 邮箱名称
      this.emailName = this.vcode.substring(0, index);
      // 验证码
      this.code = this.vcode.substr(index + 3, 6);
    }
  },
  methods: {
    ...mapMutations([
      "toastshow",
      "toastHidden",
      "manyLoginToastshow",
      "bgcisshow",
      "isShowSliderVerifyHandle"
    ]),
    onSuccess() { },
    /* 滑动验证异常*/
    onAgain() {
      this.$message.error("滑动操作异常，请重试")
    },
    closeDialog() { },
    phoneValidator(rule, value, callback) {
      if (this.phoneErr) {
        return callback(new Error("该手机号已被其他账号绑定"));
      } else {
        callback();
      }
    },
    backfindpassword() {
      this.$router.push("/user/reset-pass");
    },
    async isShowPhoneCode() {
      this.urlemail = getQueryString("email");
      this.urlcode = getQueryString("code");

      const res = await getToResetEmail({
        email: this.urlemail,
        vcode: this.urlcode,
      });

      if (res.data.status == 200) {
        //成功，就不需要手机了
        this.showpage = 1;
      } else if (res.data.status == 307) {
        //不成功需要手机
        this.showpage = 2;
      } else {
        //通用页面
        this.showpage = 0;
        this.bgcisshow(1);
      }
      this.showcode = res.data.status;
    },
    show(message = "默认", duration = 3000) {
      this.toastshow(message);

      setTimeout(() => {
        this.toastHidden();
      }, duration);



      const toastTimer = setTimeout(() => {
        this.toastHidden();
        clearTimeout(toastTimer)
      }, duration);
    },
    pwdvalidator(rule, value, callback) {
      if (this.pwdError) {
        return callback(
          new Error("请输入正确验证码，连续输入错误，账号将被锁定")
        );
      } else {
        callback();
      }
    },

    // 清除单个表单项验证
    clearVerify(refName, item) {
      this.$refs[refName].clearValidate(item);
    },
    openPwd() {
      if (this.passwordFlag == "password") {
        this.passwordFlag = "text";
      } else {
        this.passwordFlag = "password";
      }
    },
    openPwd1() {
      if (this.passwordFlag1 == "password") {
        this.passwordFlag1 = "text";
      } else {
        this.passwordFlag1 = "password";
      }
    },
    codeChange() {
      this.codeErr = false;
    },
    //点击验证码
    clickCode() {

      if (this.codeBtnVal != "获取验证码") return;

      if (
        !this.pwdForm.phone ||
        this.pwdForm.phone.length < 11 ||
        this.pwdForm.phone[0] != 1
      ) {
        this.$refs["pwdForm"].validateField("phone");
        return;
      }
      localStorage.setItem('currUserPhone', this.pwdForm.phone)
      this.isShowSliderVerifyHandle(true)
    },
    // 获取验证码
    getCode(validCode) {
      let _this = this;
      let obj = {
        mobileOrEmail: this.pwdForm.phone,
        vType: 1,
        messageType: 1,
        validCode: validCode
      };
      this.codeBtnVal = "发送中...";
      getDynamicCode(obj).then((res) => {
        let data = res.data;
        if (data.success) {
          let num = 60;
          var timer = setInterval(() => {
            if (num <= 0) {
              _this.codeBtnVal = "获取验证码";
              clearInterval(timer);
            } else {
              _this.codeBtnVal = num-- + "s";
            }
          }, 1000);
        } else {
          if (data.code == 401) {
            this.phoneErr = true;
            this.$refs["pwdForm"].validateField("phone");
            setTimeout(() => {
              this.phoneErr = false;
              this.pwdForm.phone = "";
              this.$refs["pwdForm"].validateField("phone");
              this.clearVerify("pwdForm", "phone");
            }, 2000);
          } else {
            this.codeerrorMessage = data.developerMsg;
            this.codeErr = true;
            this.$refs["pwdForm"].validateField("code");
          }
          this.codeBtnVal = "获取验证码";
        }
      });
    },
    // 重新输入密码校验
    confirmPwdValidator(rule, value, callback) {
      if (value != this.pwdForm.password) {
        return callback(new Error("两次输入的密码不一致!"));
      } else {
        callback();
      }
    },
    confirmPwdValidator2(rule, value, callback) {

      if (value != this.pwdForm2.password2) {
        return callback(new Error("两次输入的密码不一致!"));
      } else {
        callback();
      }
    },
    // 动态验证码校验
    codeValidator(rule, value, callback) {
      if (this.codeErr) {
        return callback(new Error(this.codeerrorMessage));
      } else {
        callback();
      }
    },
    toHome() {
      this.$router.push({
        name: "login",
        query: {
          refer: this.referUrl ? this.referUrl : undefined,
          codeLogin: this.codeLogin ? this.codeLogin : undefined,
        },
      });
    },
    // 重置并登录
    findpwd() {
      if (this.registerName != "重置并登录") {
        return;
      }

      let did = zhuge.getDid();
      let sid = zhuge.getSid();
      if (this.showcode == 307) {
        this.$refs["pwdForm"].validate((valid) => {
          if (valid) {
            this.registerName = "重置中";
            let bindParams = {
              mobile: this.pwdForm.phone,
              dynamicCode: this.pwdForm.code,
              password: this.pwdForm.password,
              additional: did + "@" + sid,
              rememberme: "1",
              email: this.urlemail,
            };
            bindEmail(bindParams).then((res) => {
              if (res.data.code == 200) {
                let obj = {
                  username: this.urlemail,
                  password: this.pwdForm.password,
                  code: this.urlcode,
                };
                resetUserPassword(obj).then((res) => {
                  let data = res.data;
                  if (data.status == 200) {
                    localStorage.removeItem(this.pwdForm.phone);
                    jumpAfterLogin(this.referUrl);
                    zhugeTrack("Web_绑定并登录成功");
                    this.registerName = "重置并登录";
                  } else if (data.status == 403) {
                    this.show("验证已失效，请重新进行手机验证");
                    setTimeout(() => {
                      this.$router.push("/user/reset-pass");
                    }, 3000);
                    this.registerName = "重置并登录";
                  } else if (data.status == 423) {
                    this.manyLoginToastshow();
                    this.registerName = "重置并登录";
                  } else {
                    this.show("绑定登录失败");
                    this.registerName = "重置并登录";
                  }
                });
              } else if (res.data.code == 403) {
                this.codeErr = true;
                this.codeerrorMessage =
                  "请输入正确验证码，连续输入错误，账号将被锁定";
                this.$refs["pwdForm"].validateField("code");

                this.registerName = "重置并登录";
              } else if (res.data.code == 401) {
                this.show("重置登录失败");
                this.registerName = "重置并登录";
              } else if (res.data.code == 423) {
                this.manyLoginToastshow();
                this.registerName = "重置并登录";
              } else {
                this.show("重置登录失败");
                this.registerName = "重置并登录";
              }
            });
          }
        });
      } else if (this.showcode == 200) {
        this.$refs["pwdForm2"].validate((valid) => {
          if (valid) {
            this.registerName = "重置中";

            let obj = {
              username: this.urlemail,
              password: this.pwdForm2.password2,
              code: this.urlcode,
            };
            resetUserPassword(obj).then((res) => {
              let data = res.data;
              if (data.status == 200) {
                let params = {
                  userName: this.urlemail,
                  passWord: this.pwdForm2.password2,
                  additional: did + "@" + sid,
                  rememberMe: 1,
                };
                userLogin(params).then((res) => {
                  if (res.data.code == 200) {
                    // 登录成功后的跳转
                    this.registerName = "重置并登录";
                    jumpAfterLogin(this.referUrl);
                    zhugeTrack("登录成功", {
                      终端: "Web",
                      登陆方式: "忘记密码"
                    });
                  } else {
                    this.registerName = "重置并登录";
                    this.show("重置密码失败");
                  }
                });
                zhugeTrack("密码重置成功", {
                  终端: "Web",
                  事由: "修改密码，忘记密码"
                });
              } else if (data.status == 401) {
                this.registerName = "重置并登录";
                this.show("重置密码失败");
              } else if (data.status == 403) {
                this.show("验证已失效，请重新进行邮箱验证");
                this.registerName = "重置并登录";
                setTimeout(() => {
                  this.$router.push("/user/reset-pass");
                }, 3000);
              } else {
                this.show("重置密码失败");
                this.registerName = "重置并登录";
              }
            });
          }
        });
      } else {
        this.show("重置密码失败");
        this.registerName = "重置并登录";
      }
    },
    toPass() {
      this.$router.push({
        name: "reset-pass",
        query: {
          refer: this.referUrl ? this.referUrl : undefined,
        },
      });
    },
    // 清除单个表单项验证
  },
  metaInfo() {
    return {
      title: window.location.search.indexOf('match')>-1?'忘记密码 - 传智杯大赛官网-全国大学生计算机应用能力与数字素养大赛':'忘记密码 - 博学谷·黑马程序员线上品牌',
      meta: [
        {
          name: "keyWords",
          content: "重置密码,入口,学习中心,账号,登录,密码,找回,博学谷",
        },
        {
          name: "description",
          content:
            "博学谷找回密码入口，学员忘记学习账号登录密码，可以通过此入口重置密码，找回登录密码后可以重新登录学习账号，在线学习所报名的视频课程或视频教程，如找回密码失败可咨询客服老师或拨打客服电话：010-5628 8220。",
        },
      ],
      link: [{ rel: "icon", type: "image/x-icon", href: window.location.search.indexOf('match')>-1?'/favicon.czb.ico':'/favicon.ico' }]
    };
  },
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1280px) {
  .content {
    right: 120px !important;
  }
}

@media screen and (min-width: 1920px) {
  .content {
    right: 440px !important;
  }
}

@media screen and (min-width: 1281px) and (max-width: 1919px) {
  .content {
    right: 200px !important;
  }
}

.bgc {
  background: url("../assets/reset-pass/reset-pass-bg.png") center center;
}

.reset-pass {
  ::v-deep input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 1000px white inset !important;
  }

  .t-message {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: -24px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #1d2129;
    width: max-content;
    height: 48px;
    background: #ffffff;
    box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08),
      0px 3px 6px -4px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    border: 1px solid #e5e6eb;
  }

  .toast {
    z-index: 999;
    position: absolute;
    top: 40%;
    background-color: rgba(0, 0, 0, 0.6);
    border-radius: 20px;
    z-index: 1000;
    left: 50%;
    transform: translateX(-50%);
    color: #fff;
    font-size: 26px;
    padding: 30px 71px;
    text-align: center;
    white-space: nowrap;
  }

  .content {
    width: 464px;
    height: 660px;
    background: #ffffff;
    box-shadow: 0px 12px 40px 16px rgba(8, 25, 93, 0.03),
      0px 8px 20px 0px rgba(8, 25, 93, 0.06),
      0px 4px 8px 0px rgba(8, 25, 93, 0.08);
    border-radius: 8px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 200px;
    box-sizing: border-box;

    h1 {
      height: 32px;
      font-size: 24px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #1d2129;
      line-height: 32px;
      margin: 48px auto 24px;
      text-align: center;
    }

    .tab-check {
      display: flex;
      padding-left: 48px;
    }

    .p1 {
      height: 24px;
      border-radius: 4px 4px 0px 0px;
      margin-right: 32px;
      line-height: 24px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 600;
      color: #165dff;
      cursor: pointer;

      &::after {
        content: "";
        width: auto;
        height: 3px;
        background: #165dff;
        border-radius: 4px 4px 0px 0px;
        display: block;
        margin-top: 7px;
      }
    }

    .p2 {
      height: 24px;

      cursor: pointer;
      border-radius: 4px 4px 0px 0px;
      margin-right: 32px;
      line-height: 24px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;

      color: #4e5969;

      &:hover {
        color: #165dff;
      }
    }
  }

  .height1 {
    height: 520px;
  }

  .height2 {
    height: 660px;
  }

  .open-pwd {
    width: 14px;
    height: 14px;
    position: absolute;
    cursor: pointer;
    top: 50%;
    right: 19px;
    transform: translateY(-50%);
    opacity: 0.6;

    &:hover {
      opacity: 1;
    }

    i {
      line-height: 14px;
    }
  }

  .icon1 {
    background: url("../assets/login/icon／preview-close\(2\).png");
    background-size: 100% 100%;
    opacity: 1;
    width: 16px;
    height: 16px;
    background-size: cover;
  }

  .icon2 {
    background: url("../assets/login/icon／preview-open.png");
    background-size: 100% 100%;
    width: 16px;
    height: 16px;
    background-size: cover;
    opacity: 1;
  }

  .content1 {
    margin-top: 42px;
    padding: 0 48px;
    box-sizing: border-box;

    .email-info {
      margin-top: 32px;
    }

    .pwd-item {
      position: relative;

      .speed {
        justify-content: center;
      }

      // 重置密码
      .pwd-reset {
        position: relative;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        height: 100%;
        align-content: flex-start;

        .code-item {
          position: relative;

          ::v-deep .el-form-item__content {
            display: flex;
          }

          ::v-deep .el-input {
            display: flex;
            width: 240px;

            .el-input__inner {
              width: 240px;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              overflow: hidden;
            }
          }

          .get-code {
            width: 112px;
            height: 40px;
            background: #e8f3ff;
            border-radius: 4px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #4e5969;
            line-height: 40px;
            text-align: center;
            margin-left: 16px;
            cursor: pointer;

            &:hover {
              color: #165dff;
            }
          }

          .get-code2 {
            width: 112px;
            height: 40px;
            background: #e8f3ff;
            border-radius: 4px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #4e5969;
            line-height: 40px;
            text-align: center;
            margin-left: 16px;
          }
        }
      }
    }

    .code-item {
      position: relative;

      ::v-deep .el-form-item__content {
        display: flex;
      }

      ::v-deep .el-input {
        display: flex;
        width: 240px;

        .el-input__inner {
          width: 240px;
          height: 40px;
          border-radius: 4px;
          line-height: 40px;
        }
      }

      .get-code {
        width: 112px;
        height: 40px;
        background: #e8f3ff;
        border-radius: 4px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #4e5969;
        line-height: 40px;
        text-align: center;
        margin-left: 16px;
        cursor: pointer;

        &:hover {
          color: #165dff;
        }
      }

      .get-code2 {
        width: 112px;
        height: 40px;
        background: #e8f3ff;
        border-radius: 4px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #4e5969;
        line-height: 40px;
        text-align: center;
        margin-left: 16px;
      }
    }
  }

  .btn-box {
    width: 368px;
    height: 44px;
    border-radius: 4px;
    margin-top: 33px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;

    letter-spacing: 0;
    cursor: pointer;
    text-align: center;
    line-height: 40px;
    background-color: #4080ff;

    p:nth-child(2) {
      height: 40px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #86909c !important;
      line-height: 20px;
      position: relative;
      padding-left: 8px;
      margin-top: 16px;
      color: red;
      text-align: left;

      &::before {
        content: "*";
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #86909c;
        line-height: 20px;
        position: absolute;
        top: 0;
        left: -5px;
      }
    }

    .btn {
      color: #ffffff;
    }

    &:hover {
      background: #165dff;
    }

    .p3 {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      text-align: center;
      margin-top: 24px;

      span {
        color: #4e5969;
        cursor: pointer;

        &:hover {
          color: #165dff !important;
        }
      }
    }
  }

  .noInfo {
    width: 300px;
    margin: 212px auto 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    img {
      width: 180px;
      height: 130px;
    }

    p {
      margin: 12px auto 16px;
      height: 22px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #86909c;
      line-height: 22px;
    }

    .btn {
      width: 88px;
      height: 32px;
      background: #165dff;
      border-radius: 4px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 32px;
      text-align: center;
      cursor: pointer;

      &:hover {
        background: #4080ff;
      }
    }
  }
}
</style>
